function useStyles() {
    return {
        container: {
            width: 'fit-content',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            backgroundColor: 'white',
            padding: '5px 10px',
            borderRadius: '8px',
        },
        icon: {
            height: '1.8rem'
        }
    }
}

export { useStyles }